import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API, {
  Comprobante,
  ComprobanteNotificacion,
  CreateComprobantePayload,
  ObtenerComprobantePayload,
  PagarComprobantePayload
} from './comprobantesAPI';
import { RootState } from '../../store';
import { getErrorMessage } from '../../utils/errorHandler';

interface ComprobantesState {
  status: 'loading' | 'idle' | 'error' | 'success';
  error?: string;
  current?: Comprobante | ComprobanteNotificacion
}

export const initialState: ComprobantesState = {
  status: 'idle',
};

export const createComprobante = createAsyncThunk(
  'comprobantes/crear', async (payload: CreateComprobantePayload, thunkAPI) => {
    try {
      const response = await API.create(payload);

      if (response.status !== 'ok') {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(getErrorMessage(err));
    }
  });


export const payComprobante = createAsyncThunk(
  'comprobantes/pagar', async (payload: PagarComprobantePayload, thunkAPI) => {
    try {
      const response = await API.pay(payload);

      if (response.status === 'error') {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(getErrorMessage(err));
    }
  });

export const getComprobante = createAsyncThunk(
  'comprobantes/obtener',
  async (payload: ObtenerComprobantePayload, thunkAPI) => {
    try {
      const response = await API.get(payload);

      if (response.status === 'error') {
        return thunkAPI.rejectWithValue(response.error);
      }

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(getErrorMessage(err));
    }
  }
);

export const comprobantesState = createSlice({
  name: 'ComprobantesState',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(createComprobante.pending, state => {
        state.status = 'loading';
      })
      .addCase(createComprobante.fulfilled, (state, action) => {
        state.status = 'success';
        state.current = action.payload;
      })
      .addCase(createComprobante.rejected, (state, action) => {
        state.status = 'error',
          state.error = action.error.message;
      });

    builder
      .addCase(getComprobante.pending, state => {
        state.status = 'loading';
      })
      .addCase(getComprobante.fulfilled, (state, action) => {
        state.status = 'success';
        state.current = action.payload;
      })
      .addCase(getComprobante.rejected, (state, action) => {
        state.status = 'error',
          state.error = action.error.message;
      });
  },
});

export const currentComprobante = (state: RootState) => state.comprobantes.current;

export default comprobantesState.reducer;
